import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CancelIcon from '@mui/icons-material/Cancel';
import Divider from "@mui/material/Divider";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Table from '../helpers/Table'
import DeletePopup from "../helpers/DeletePopup";

import { addDriver, editDriver, deleteDriver } from "../../actions/valueActions";

import { convertBoolDiffValue } from "./valueFunctions";
import RiskValueDriverLitigationForm from "./RiskValueDriverLitigationForm";
import { getIconFromDriverName } from "./iconFunctions";
import { getAllOutcomes } from "./valueFunctions";

const RiskValueDriverLitigation = ({ id, valueModel, risks, driver, outcome }) => {
    const formikRef = useRef(null);
    const dispatch = useDispatch();

    // const [selectedRisk, setSelectedRisk] = useState(risks[0]['name'] || '')
    const [deleteLitigationDriverPopupOpen, setDeleteLitigationDriverPopupOpen] = useState(false);
    const [deleteLitigationDriverId, setDeleteLitigationDriverId] = useState(null);
    const [editLitigationDriverId, setEditLitigationDriverId] = useState(null);

    const openDeleteLitigationDriver = (id) => {
        setDeleteLitigationDriverId(id)
        setDeleteLitigationDriverPopupOpen(true)
    }

    const editLitigationDriver = (id) => {
        setEditLitigationDriverId(id)
        // let litigationDriver = valueModel.risk_value_driver?.litigation_reduction.find(litigationDriver => litigationDriver.id === id)

        // setSelectedRisk(litigationDriver?.type)
    }

    const onSubmitLitigation = async (values, { setSubmitting, setErrors }) => {
        // Clone the values object to avoid direct mutation
        const clonedValues = { ...values };
        clonedValues.id = editLitigationDriverId;
        if (outcome) {
            clonedValues.outcome = outcome
        }

        let success = false

        if (editLitigationDriverId) {
            const result = await dispatch(editDriver('litigation', id, clonedValues, { setSubmitting, setErrors }))
            success = result?.success;
            if (success) {
                setEditLitigationDriverId(null)
            }
        }
        else {
            const result = await dispatch(addDriver('litigation', id, clonedValues, { setSubmitting, setErrors }))
            success = result?.success;
        }

        if (formikRef.current && success) {
            formikRef.current.resetForm();
        }
    }

    const handleResetLitigation = () => {
        setEditLitigationDriverId(null)

        // Access the formikRef current value and call resetForm
        if (formikRef.current) {
            formikRef.current.resetForm();
        }
    };

    const litigationDriverColumns = [
        { id: 'outcome', label: 'Outcome', minWidth: 170, action: false },
        { id: 'driver_name', label: 'Name', minWidth: 170, action: false },
        // { id: 'sub_risk', label: 'Employee', format: (value) => formatString(value), minWidth: 100, action: false },
        // { id: 'multiple_type', label: 'Type', format: (value) => firstCharToUpper(value), minWidth: 100, action: false },
        { id: 'risk_reduction', label: 'Risk', minWidth: 100, action: false },
        // { id: 'occurrence', label: 'Occurrence', format: (value) => value + ' %', minWidth: 100, action: false },
        { id: 'positive_driver', label: 'Differentiation value', minWidth: 100, format: (value) => convertBoolDiffValue(Boolean(value)), action: false },
        { id: 'actions', label: 'Actions', minWidth: 100, action: false },
    ];

    const createLitigationDriverData = (id, outcome, driver_name, risk_reduction, positive_driver, actions) => {
        risk_reduction = `${risk_reduction} % ${positive_driver ? 'reduction' : 'increase'}`
        return { id, outcome, driver_name, risk_reduction, positive_driver, actions };
    }

    const litigationDriverActions = (id) => {
        return (
            <React.Fragment>
                <IconButton size="small" onClick={() => editLitigationDriver(id)}>
                    <EditIcon />
                </IconButton>
                <IconButton size="small" onClick={() => openDeleteLitigationDriver(id)}>
                    <DeleteIcon />
                </IconButton>
            </React.Fragment>
        )
    }

    const litigationDriverRows = valueModel.risk_value_driver?.litigation_reduction.filter(driver => !outcome || driver.outcome === outcome).map((driver) => {
        return (
            createLitigationDriverData(driver.id, driver.outcome, driver.driver_name, driver.risk_reduction, driver.positive_driver, litigationDriverActions(driver.id))
        )
    })

    const litigationDriverTable = () => {
        return (
            <React.Fragment>
                <Divider />
                <Table
                    columns={litigationDriverColumns}
                    rows={litigationDriverRows}
                    selectedId={editLitigationDriverId}
                />
            </React.Fragment>
        )
    }

    const litigationDriverFormActions = () => {
        return (
            <React.Fragment>
                {editLitigationDriverId ? null
                    : <Button variant="contained" startIcon={<Box component={getIconFromDriverName(driver)} />} size="small" type="submit">Add driver</Button>
                }
                {editLitigationDriverId ?
                    <Stack direction="row" spacing={2}>
                        <Button variant="contained" startIcon={<EditIcon />} size="small" type="submit">Save</Button>
                        <Button variant="contained" startIcon={<CancelIcon />} size="small" onClick={handleResetLitigation}>Cancel</Button>
                    </Stack>
                    : null
                }
            </React.Fragment>
        )
    }

    return (
        <Box>
            <Divider sx={{ mb: 3 }} />
            <Stack gap={1} direction="row" sx={{ ml: 2 }}>
                <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                    Driver type:
                </Typography>
                <Typography variant="caption">
                    Litigation Risk Reduction
                </Typography>
            </Stack>


            <RiskValueDriverLitigationForm
                currency="€"
                outcome={outcome}
                outcomeList={getAllOutcomes(valueModel?.driver_analysis)}
                ownProduct={valueModel.product}
                riskStructure={risks}
                editLitigationDriverId={editLitigationDriverId}
                editLitigationDriver={valueModel.risk_value_driver?.litigation_reduction.find(litigationDriver => litigationDriver.id === editLitigationDriverId)}
                formActions={litigationDriverFormActions}
                onSubmit={(values, { setSubmitting, setErrors }) => onSubmitLitigation(values, { setSubmitting, setErrors })}
                ref={formikRef}
            />
            {litigationDriverTable()}
            <DeletePopup open={deleteLitigationDriverPopupOpen} onClose={() => setDeleteLitigationDriverPopupOpen(false)} onDelete={() => dispatch(deleteDriver('litigation', id, deleteLitigationDriverId))} />
        </Box>
    )
}

export default RiskValueDriverLitigation